export const requiredBillingFields = [
  { key: 'address_1', label: 'Address 1' },
  { key: 'city', label: 'City' },
  { key: 'state', label: 'State' },
  { key: 'zip', label: 'Zip' },
] as const

type RequiredBillingKey = (typeof requiredBillingFields)[number]['key']
type BillingAddress = Partial<Record<RequiredBillingKey, unknown>> & Record<string, unknown>

const hasTrimmedValue = (value: unknown) =>
  value !== null && value !== undefined && String(value).trim().length > 0

export const requiredTrimmedRule = (label: string) => (value: unknown) =>
  hasTrimmedValue(value) || `${label} is required.`

export const getRequiredBillingErrors = (billing?: BillingAddress | null) =>
  requiredBillingFields
    .filter(({ key }) => !hasTrimmedValue(billing?.[key]))
    .map(({ label }) => `${label} is required.`)

export const trimRequiredBillingFields = (billing?: BillingAddress | null): BillingAddress => {
  const trimmed = { ...billing }

  requiredBillingFields.forEach(({ key }) => {
    if (typeof trimmed[key] === 'string') {
      trimmed[key] = trimmed[key].trim()
    }
  })

  return trimmed
}
